export enum AttachmentUploadPermissions {
  ALLOW_DOCUMENTS = 'UPLOAD_ATTACHMENT_DOCUMENT',
  ALLOW_IMAGES = 'UPLOAD_ATTACHMENT_IMAGE',
}
